__turbopack_context__.v({
  "container": "CVGpba_container",
  "contentContainer": "CVGpba_contentContainer",
  "disabled": "CVGpba_disabled",
  "selectable": "CVGpba_selectable",
});
